import React from "react";
import { Form, Tabs, Row, Col, Input, InputNumber, Select, Typography, DatePicker, Radio } from "antd";

// 公共组件
import SPRadioWithEnum from "../SPRadioWithEnum";
// import SPDatePicker from "../SPDatePicker";

// 应该是公共组件，但还未抽成公共组件
import SPRangePicker from "components/base/SPRangePicker";
import SPBlockTitle from 'components/base/SPBlockTitle';

// 页面组件
import SPSelectWithApi from "../../product-price/base/SPSelectWithApi";
import SPSelectWithEnum from "../../product-price/base/SPSelectWithEnum";
import MyModelCascader from "../../product-price/base/vehicle-cascader-model";
import DepreciationCost from "../../product-price/value-added-price/drawer/depreciation-cost";
import ServiceTypeAggregation from "../../product-price/value-added-price/drawer/related-field";
import ParkingFee from "../../product-price/value-added-price/drawer/parking-fee";
import BookingRules from '../../product-price/base/BookingRules';
import CancelBookingRules from '../../product-price/base/CancelBookingRules';
import ServicePolicy from '../../product-price/base/ServicePolicy';
import UseCarLimit from "components/product-price/service-policy-template/drawer/use-car-limit";
import TextByName from "../../../components/order-management/base/text-by-name";
import SPUploadPhotos from "components/base/SPUploadPhotos";
import OrderTab from 'components/order-management/base/OrderTab';
import EnumValueToText from '../EnumValueToText';
import HolidayTips from 'components/marketing-activities/components/HolidayTips';


import { SPParagraph } from './SPParagraph'
import { SPTitle } from './SPTitle'
import SPText from '../SPText'
import { SPSelect } from './SPSelect'
import { SPMileLimitSelect } from './SPMileLimitSelect'
import ScopeOfCompensation from "../../product-price/value-added-price/drawer/scope-of-compensation";
import SPDeCodeInput from "../SPDeCodeInput";
import DiscountPlan from 'components/marketing-activities/components/DiscountPlan';
import SPImagesPreview from 'components/base/SPImagesPreview';
import PRTimeLimit from 'components/marketing-activities/components/PRTimeLimit';

const { TextArea } = Input;

const dynamicTagFactory = (tag: any) => {
  // 组件
  if (tag === 'SPRadioWithEnum') return SPRadioWithEnum;
  // if (tag === 'SPDatePicker') return SPDatePicker;
  if (tag === 'SPRangePicker') return SPRangePicker;
  if (tag === 'SPParagraph') return SPParagraph;
  if (tag === 'SPTitle') return SPTitle;
  if (tag === 'SPText') return SPText;
  if (tag === 'input') return Input;
  if (tag === 'inputNumber') return InputNumber;
  if (tag === 'select') return Select;
  if (tag === 'SPSelect') return SPSelect;
  if (tag === 'SPMileLimitSelect') return SPMileLimitSelect;
  if (tag === 'apiSelect') return SPSelectWithApi;
  if (tag === 'enumSelect') return SPSelectWithEnum;
  if (tag === 'cascader') return MyModelCascader;
  if (tag === 'depreciationCost') return DepreciationCost;
  if (tag === 'parkingFee') return ParkingFee;
  if (tag === 'serviceTypeAggregation') return ServiceTypeAggregation;
  if (tag === 'BookingRules') return BookingRules;
  if (tag === 'CancelBookingRules') return CancelBookingRules;
  if (tag === 'ServicePolicy') return ServicePolicy;
  if (tag === 'UseCarLimit') return UseCarLimit;
  if (tag === 'TextByName') return TextByName;
  if (tag === 'TextArea') return TextArea;
  if (tag === 'TextArea') return TextArea;
  if (tag === 'DatePicker') return DatePicker;
  if (tag === 'SPUploadPhotos') return SPUploadPhotos;
  if (tag === 'OrderTab') return OrderTab;
  if (tag === 'RadioGroup') return Radio.Group;
  if (tag === 'ScopeOfCompensation') return ScopeOfCompensation;
  if (tag === 'SPDeCodeInput') return SPDeCodeInput;
  if (tag === 'EnumValueToText') return EnumValueToText;
  if (tag === 'DiscountPlan') return DiscountPlan;
  if (tag === 'SPImagesPreview') return SPImagesPreview;
  if (tag === 'HolidayTips') return HolidayTips;
  if (tag === 'PRTimeLimit') return PRTimeLimit;
  // 默认
  return Input;
};

const dynamicTagCreator = (data: any, enums: any, echoData: any) => {

  return data.map((sectionData: any) => {
    const { xtype, xprops, children } = sectionData

    switch (xtype) {
      case 'grid':
        return (
          <Row>
            {children.map((field: any) => {
              const Tag: React.ElementType = dynamicTagFactory(field.xtype);
              return (
                <Col span={24/xprops.colums} style={{ paddingRight: '12px' }}>
                  <Form.Item name={field?.name} extra={field?.xprops?.extra}  initialValue={field?.xprops?.initialValue}  rules={field?.rules} label={field?.xprops?.label}>
                    <Tag {...field.xprops} enums={enums} data={echoData} />
                  </Form.Item>
                </Col>
              );
            })}
          </Row>
        );
      case 'tabs':
        return (
          <Tabs
            {...xprops}
            items={
              children.map((tab: any, i: number) => ({
                ...tab.xprops,
                key: `${i}`,
                children: tab.children.map((rowData: any) => dynamicTagCreator([rowData], enums, echoData))
              }))
            }
          />
        );
      case 'typography':
        return (
          <Typography>
            {children.map((field: any, index: number) => {
              if (field.xtype === 'title') {
                return <SPBlockTitle key={index} title={field.title} />;
              }
              const Tag: React.ElementType = dynamicTagFactory(field.xtype);
              return <Form.Item key={index} name={field?.name} initialValue={field?.xprops?.initialValue} label={field?.xprops.label}>
                <Tag {...field.xprops} enums={enums} data={echoData}/>
              </Form.Item>
            })}
          </Typography>
        );
      default:
        break;
    }
  });
};

interface IComponentProps {
  data: any;
  enums?: any;
  echoData?: any;
}
const SPDynamicFormRender: React.FC<IComponentProps> = (props) => {
  const { data, enums, echoData } = props;
  return dynamicTagCreator(data, enums, echoData);
};

export default SPDynamicFormRender;

